import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import { getProjectPaymentReviewApproveById } from '../../redux/actions/withdrawReviewPayment'
import ProjectWaitForWithdrawTableWidget from '../../widgets/admin/ProjectWaitForWithdrawTableWidget'
import WithdrawalPanel from '../../widgets/admin/WithdrawalPanel'
import TableLoadingTemplate from '../../widgets/loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'
import DashboradToggle from '../../widgets/dashboard/DashboradToggle'

export default function ApproveWithdrawReviewDashboard({ config, onSettingChange = () => {} }) {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [projectVersionId, setProjectVersionId] = useState()
  const [projectPaymentReviewId, setProjectPaymentReviewId] = useState()
  const [showTableDetail, setShowTableDetail] = useState(true)

  useEffect(() => {
    // if (config) {
    //   setSchema(config.schema)
    // } else {
    //   handleGetSchema()
    // }

    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    // startLoading()
    try {
      const response = await getProjectPaymentReviewApproveById(null)

      console.warn('response ', response)
      setSchema(response.model)
    } catch (e) {
      console.error('Error ', e)
      setError({})
    }
    // doneLoading()
    setIsLoading(false)
  }

  const handleOnSelectedRowData = async (rowData) => {
    setIsLoading(true)
    // startLoading()
    setProjectVersionId()
    setProjectPaymentReviewId()
    try {
      console.log(rowData)
      const response = await getProjectPaymentReviewApproveById(rowData.projectPaymentReviewId)
      response.model.forms.projectBudgetPlan.masterBudgetPlan.label = 'แผนงบประมาณ'
      // console.log('res => ', response.model.forms.projectBudgetPlan.masterBudgetPlan.label)
      setShowTableDetail(false)
      setProjectVersionId(rowData.projectVersionId)
      setProjectPaymentReviewId(rowData.projectPaymentReviewId)
      setSchema(response.model)
    } catch (e) {
      setError({})
    }
    // doneLoading()
    setIsLoading(false)
  }

  const handleOnCancelShowTable = () => {
    setShowTableDetail(true)
    setProjectVersionId()
    setProjectPaymentReviewId()
  }

  if (!schema) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {config && (
        <DashboradToggle
          onChange={onSettingChange}
          dashboradName={config.key}
          checked={config.show}
          style={{ marginTop: 20, marginBottom: -15 }}
        />
      )}

      <Panel
        header={'อนุมัติเบิกจ่ายเงินโครงการ'}
        shaded
        collapsible
        bordered
        defaultExpanded
        style={{ marginTop: 20 }}
      >
        <ProjectWaitForWithdrawTableWidget
          onSelectedRowData={handleOnSelectedRowData}
          isApproveTable={true}
          onShow={showTableDetail}
          onChangeShow={() => setShowTableDetail(!showTableDetail)}
          searchType={'inputs'}
          statusOptions={schema?.forms?.statusOptions || []}
          statusOptionsForApprover={schema?.forms?.statusOptionsForApprover || []}
        />
        <br />
        {schema?.forms && projectVersionId && (
          <WithdrawalPanel
            schema={schema.forms}
            projectVersionId={projectVersionId}
            projectPaymentReviewId={projectPaymentReviewId}
            onCancelShowTable={handleOnCancelShowTable}
          />
        )}
        <br />
      </Panel>
    </>
  )
}
